import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalFinancingDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Manually approve an applied or incomplete Credit Human Existing Loan
 * Application. The response is the financing read; Mark Approved never
 * returns a handoff URL.
 */
export default function useMarkApprovedBatteryCreditHumanApplication(): UseMutationResult<
  BatteryProposalFinancingDto,
  unknown,
  { proposalId: string; applicationId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId }) =>
      batteryProposalService.markApprovedCreditHumanApplication(
        proposalId,
        applicationId,
      ),
    onSuccess: (financing, { proposalId, applicationId }) => {
      queryClient.setQueryData(
        queryKeys.batteryProposal.financing(proposalId),
        financing,
      )
      // Mark Approved records a provider_decision activity event; the drawer
      // timeline reads a separate active-loan activity query.
      void queryClient.invalidateQueries({
        queryKey: queryKeys.activeLoan.activity(applicationId),
      })
    },
  })
}
